import Header from 'components/headers/bulletins'
import Footer from './footer'
import useGetSettlements from './hooks/useGetSettlements'
import DotsLoading from 'components/loadings/dotsLoading'
import { useCallback } from 'react'
import Item from './item'
import InfiniteScroll from 'react-infinite-scroll-component'

export default function SettlementPage() {
    const { settlements, isLoadingSettlements, fetchNextPage, refetch } =
        useGetSettlements()
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])
    return (
        <div className=" relative min-h-screen">
            <Header title="درخواست تسویه و خروج" />
            {isLoadingSettlements ? (
                <DotsLoading />
            ) : (
                <InfiniteScroll
                    next={onWatchEnd}
                    hasMore={
                        settlements
                            ? settlements?.pages[settlements.pages.length - 1]
                                  .next
                                ? true
                                : false
                            : false
                    }
                    dataLength={
                        settlements
                            ? settlements.pages.flatMap((x) => x.results).length
                            : 0
                    }
                    loader={<DotsLoading />}
                >
                    <div>
                        {settlements &&
                            settlements.pages
                                .flatMap((x) => x.results)
                                .map((item) => (
                                    <Item item={item} refetch={refetch} />
                                ))}
                    </div>
                </InfiniteScroll>
            )}
            <Footer refetch={refetch} />
        </div>
    )
}
